import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { PlanList_DesignPage_Query } from "./query";

type Props = {
	hotelID: string;
};

export const usePlanListQuery = ({ hotelID }: Props) => {
	const { data } = useCustomSuspenseQuery(PlanList_DesignPage_Query, { variables: { hotelID } });

	return {
		data,
	};
};
